// @flow

import ApiError from '../../entities/ApiError';

import ApiErrorUtils from '../ApiErrorUtils';

export default class MangoPayApiErrors {

  /**
   * See https://docs.mangopay.com/guide/errors
   * Section: Tokenization / Card registration errors
   *
   * TODO: I18n
   */
  static registerCreditCart(apiError: ApiError): string {
    const errors = {
      '02625': 'Invalid card number',
      '02626': 'Invalid date',
      '02627': 'Invalid CCV number',
      '02101': 'Internal error',
      '01902': 'This card is not active',
      '02624': 'Card expired',
      '02631': 'Delay exceeded',
    };

    return ApiErrorUtils.findErrorOnArray(apiError, errors, 'MangoPayApiErrors:registerCreditCart');
  }

}



// WEBPACK FOOTER //
// ./sdk/scripts/utils/apiErrors/MangoPayApiErrors.js